<template  #body="slotProps">
  <div class="card">
<DataTable
  :value="tableData"
  :rows="rows"
  :paginator="true"
  :loading="isLoading"
  :rowsPerPageOptions="rowsPerPageOptions"
  lazy
  @page="onPaginate"
  :currentPage="currentPage"
  :totalRecords="totalRecords"
>
  <template #header>
    <div class="search-container">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="criteria"
                placeholder="Rechercher un produit"
                @keyup.enter="onFilterDt"
                @input="onClearInputFilter"
              />
            </span>
    </div>
  </template>
  <div class="card-body pt-0">
    <Column field="stockId" header="Id de stock" />
    <Column field="productName" header="Nom du produit" />
    <Column field="supplierName" header="Fournisseur" />
    <Column field="stockType" header="Type de stock">
      <template #body="slotProps">
        {{ slotProps.data.stockType == 1 ? 'Partagé' : 'Individuel' }}
      </template>
    </Column>
    <Column field="status" header="Statut du stock" >
      <template #body="slotProps">
        {{ slotProps.data.status == 1 ? 'Actif' : 'Inactif' }}
      </template>
    </Column>
    <Column field="documentStock" header="Stock de document" />
    <Column field="productStock" header="Stock du produit" />
    <Column field="productStockThreshold" header="Seuil stock" />
  </div>
  <template #empty>Aucun résultat trouvé.</template>
</DataTable>
</div>
</template>
<script setup lang="ts">
import {
  ref,
  onMounted,
} from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import {fetchDocumentsStockDocuments} from "@/_services/document/document";

const isLoading = ref<boolean>(true);
const documents = Array<Document>();
const tableData = ref<Array<Document>>(documents);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const defaultRowsPerPage = 10;
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const criteria = ref<string>("");


onMounted(async () => {
  showSpinner();
  await populateDatatable();
});
async function populateDatatable() {
  const [loadingDt, totalRecordsDt, tableDataDt] = await fetchDocumentsStockDocuments(1, rows.value, page.value, criteria.value);
  isLoading.value = loadingDt.value;
  tableData.value = tableDataDt.value;
  totalRecords.value = totalRecordsDt.value;
  
  if (isLoading.value === false) {
      hideSpinner();
  }
}
const onPaginate = async (e) => {
    showSpinner();
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    await populateDatatable();
};
const onFilterDt = async() => {
    showSpinner();
    rows.value = 10;
    page.value = 1;
    await populateDatatable();
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        showSpinner();
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const showSpinner = () => {
    isLoading.value = true;
}
const hideSpinner = () => {
    isLoading.value = false;
}

</script>